import { IAccessMobileServices } from 'services/RawData/accessMobile_services';
import accessMobilePage from '.';

export const createAccessMobilePage = (accessMobileServices: IAccessMobileServices) => {
  return accessMobilePage(accessMobileServices);
};
